import { Search, Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Input } from '@/components/ui/input';

interface Props {
  value: string;
  onChange: (v: string) => void;
  isLoading: boolean;
}

export function ClientSearchInput({ value, onChange, isLoading }: Props) {
  const hasSearch = value.trim().length > 0;

  return (
    <>
      <div
        className={cn(
          'text-center overflow-hidden transition-[max-height,opacity,margin] duration-380 ease-out',
          hasSearch ? 'max-h-0 opacity-0 mb-0' : 'max-h-40 opacity-100 mb-8'
        )}
      >
        <div className='w-14 h-14 rounded-2xl bg-primary/10 border border-primary/20 flex items-center justify-center mx-auto mb-3'>
          <Search className='w-6 h-6 text-primary' />
        </div>
        <p className='text-base font-medium text-foreground'>Найдите клиента</p>
        <p className='text-sm text-muted-foreground mt-1'>
          Введите логин, например <span className='font-mono text-xs'>lrb_375291234567</span>
        </p>
      </div>

      <div
        className={cn(
          'relative w-full transition-[max-width] duration-420 ease-out',
          hasSearch ? 'max-w-full' : 'max-w-lg'
        )}
      >
        <Search className='absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none' />
        {isLoading && (
          <Loader2 className='absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground animate-spin' />
        )}
        <Input
          autoFocus
          placeholder='Введите логин клиента'
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className='pl-11 pr-11 h-auto py-3 bg-card border-border/50 shadow-sm focus-visible:border-primary/60 focus-visible:ring-0'
        />
      </div>
    </>
  );
}
